import React, { Component, Suspense } from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import debounce from 'lodash.debounce';
import Icon from '../../../../components/Icon/Icon';
const API_URL =  process.env.REACT_APP_API_URL;

class CategoryItems extends Component {
    constructor(props) {
        super(props);

        this.state = {
            randoGuarantee: null,
            cat: this.props.initialCategory ? this.props.initialCategory : 'breakfast'
        }

        this.menuSlider = React.createRef();
        this.menuWidth = React.createRef();
        this.arrowsWrapper = React.createRef();
    }

    componentDidMount = () => {
        window.addEventListener('resize', this.handleScroll);
        this.menuSlider.current.addEventListener('scroll', this.handleScroll);
        this.menuSlider.current.scrollLeft = 0;
        this.handleScroll();
    }

    componentDidUpdate = () => {
        this.menuSlider.current.scrollLeft = 0;
        this.handleScroll();
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.handleScroll);
        this.menuSlider.current.removeEventListener('scroll', this.handleScroll);
    }

    menuItems = ''; // vertically scrolling menu items
    menuOverflowed = ''; // stores whether menu is overflowing past browser window
    arrowContainer = ''; 
    // debounce the scroll to only execute when scroll has stopped for 100ms
    handleScroll = debounce(() => {
        this.arrowContainer = this.arrowsWrapper.current;
        // using innerWidth instead of props.isDesktop, since the latter does not update on resize
        if(window.innerWidth > 850) { 
            this.menuItems = this.menuSlider.current;
            this.menuOverflowed = false;
           
            if(this.menuItems.scrollWidth > window.innerWidth) {
                this.menuOverflowed = true;
            }
            // check if menu is scrolled all the way the left
            if (this.menuItems.scrollLeft === 0) {
                // check if menu extends out of screen
                if(this.menuOverflowed) {
                    this.arrowContainer.classList.add('left');
                    this.arrowContainer.classList.remove('right');
                } else {
                    this.arrowContainer.classList.add('left', 'right');
                }
            
            } else if(this.menuItems.scrollLeft + this.menuItems.offsetWidth === this.menuItems.scrollWidth) {
                // check if menu extends out of screen
                if(this.menuOverflowed) {
                    this.arrowContainer.classList.add('right');
                    this.arrowContainer.classList.remove('left');
                } else {
                    this.arrowContainer.classList.add('right', 'left');
                }
            // since menu is neither scrolled to the left or all the way to the right, check if menu extends screen
            } else if (this.menuOverflowed) {
                this.arrowContainer.classList.remove('right', 'left');
            }
        } else {
            // mobile. hide both arrows
            this.arrowContainer.classList.add('right', 'left');
        }
    }, 100);

    shift = (count) => {
        var fromLeft = this.menuSlider.current.scrollLeft;
		var cellwidth = this.props.isDesktop ? 291*count : window.innerWidth*.45;
        //console.log('test');
        this.menuSlider.current.scroll({
            left: cellwidth+fromLeft,
            behavior: 'smooth'
            });
		return false;
	}

    clickTop = () => {
        // scroll top top of window.
        window.scroll(0,0);
    }

    getRandomGuarantee = (not) => {
        let g = this.props.categoryGuarantees;
        if (this.props.categoryGuarantees.length == 0 && this.props.categoryFood.length == 0) {
            // This category has no items, use the api's default
            g = ["eggs", "pork",  "chicken", "beef"];
        }
        if (g.length === 0){
            return false;
        }
        // Replace pork
        let baconGuarantees = g.map((item) => {
            // if(item === 'pork'){
            //     item = 'bacon';
            // }
            return item
        })
        let i = Math.floor(Math.random()*g.length);
        let randoGuarantee = baconGuarantees[i];

        // If 2nd is requested remove first guarantee from arr
        if(not){
            if (baconGuarantees.length == 1)
                baconGuarantees = ["eggs", "pork",  "chicken", "beef"];
            // console.log('not ',not);
            // console.log('state rando ',this.state.randoGuarantee);
            let guarantees = baconGuarantees.filter(item => {
                return item !== not
            })
            let i = Math.floor(Math.random()*guarantees.length);
            return guarantees[i];
        }

        
        return randoGuarantee;
    }

    shouldSubCategorize() {
        return this.props.subcategorize; //(this.props.category == 'brewbar' && (this.props.subcategory ?? '').trim().length > 0);
    }

    prepareItems = (itemsList, categoryGuarantees) => {
        let menuItems = [];
        let lang = this.props.lang;

        categoryGuarantees = categoryGuarantees.filter((a)=>a != "brewbar"); // Filter out brewbar

        // Filter out items from other subcategories, if necessary
        if (this.shouldSubCategorize()) {
            itemsList = itemsList.filter((a)=>a.subcategory == this.props.subcategory);
        }

        menuItems = itemsList.map((el, index) => {
            // el.item = el.item.replace(/\(.*\)/, '');
            // var imgsrc = "/i/menu/?i=" + i.slug + '&lang=' + i.slug + '-' + lang.getCurrent();
            // const images = require.context('../../../../assets/images/menu', true);
            // Get the images
            //  let imgSrcLang = images('./' + el.slug +'-'+ lang + '.jpg');
            let imgSrc = '/i/menu/?i='+ el.slug +'&lang='+el.slug+'-'+lang;
            //let imgSrc     = images('./' + el.slug +'.jpg');
            //let img = imgSrc ? imgSrc : imgSrcLang;
          
            var style = {
               // backgroundColor: '#fff',
                backgroundImage: 'url(' + API_URL + imgSrc + ')'
            };
            //console.log('el itemz  ',el.item);

            let clickTop = ()=>{};
            if(!this.props.ourMenuPage){
                //add click event to scroll to top
                clickTop = this.clickTop;

            }

            var menuItemName = el.item[lang] ?? "";

            // get menu item name minus last word to keep last word and arrow together
            var lastIndex = menuItemName.lastIndexOf(" ");
            // get menu item name minus last word
            var menuItemNameBegin = menuItemName.substring(0, lastIndex);
            // get last word from menu item name
            var menuItemNameEnd = menuItemName.substring(lastIndex);

           // console.log( menuItemNameBegin + menuItemNameEnd);

            return(
                <Link 
                    key={index}
                    title={el.item[lang]}
                    className="item" 
                    to={'/'+ lang + '/our-menu/' + this.props.initialCategory +'/'+ el.slug} 
                    style={style}
                    onClick={clickTop}
                >
                    <span className="item-name"><h3>{menuItemNameBegin} <span className="widont">{menuItemNameEnd} <Icon type="gt-inverted" /></span></h3></span>
                </Link>
            )
        })

        // if brewbar category, force brewbar guarantee
       // let g = this.props.match.params.category === 'brewbar' ? 'brewbar' : this.getRandomGuarantee();

        let g = this.getRandomGuarantee();
        //console.log('get rando ',g);

        // force guarantee badge if its brewbar category
        if ((this.props.initialCategory == 'featured' || this.shouldSubCategorize()) && menuItems.length >= 2) {
            // Don't show guarantees for one-liners unless there is only 1
            return(menuItems)
        }

		if (categoryGuarantees.length != 1) {

            let g1_style = {
                backgroundImage: 'url(' + API_URL + '/i/guarantees/'+ g +'-guarantee-'+ lang +'.png)'
            }
          
            let link = null;
            if (g == 'pret')
                link = <Link key="guarantee-0" to={`/${lang}/${"our-values/our-food/coffee"}`} className="item guarantees" title="Learn More" style={g1_style}><span className="guarantee-link"><h3>{this.props.lang === 'en' ? 'Learn more' : 'En apprendre plus'} <Icon type="gt-inverted" /></h3></span></Link>
            else if (g == 'location')
                link = <Link key="guarantee-0" to={`/${lang}/${"locations#brewbar"}`} className="item guarantees" title="Learn More" style={g1_style}><span className="guarantee-link"><h3>{this.props.lang === 'en' ? 'Learn more' : 'En apprendre plus'} <Icon type="gt-inverted" /></h3></span></Link>
            else
                link = <Link key="guarantee-0" to={`/${lang}/${"our-values/our-food/"}${g}`} className="item guarantees" title="Learn More" style={g1_style}><span className="guarantee-link"><h3>{this.props.lang === 'en' ? 'Learn more' : 'En apprendre plus'} <Icon type="gt-inverted" /></h3></span></Link>
			// var i = Math.floor(Math.random()*list.length);
			// list.splice(i, 0, <div key="guarantee-0" className="item guarantee">{this.wrap({slug:  g, 'item': lang.t('Learn more')}, true)}</div>);
            let index = Math.floor(Math.random() * menuItems.length);
            menuItems.splice(index, 0, link);
        }
        if(menuItems.length % 2 !== 0){

            let g2 = this.getRandomGuarantee(g);

            let g2_style ={
                backgroundImage: 'url(' + API_URL + '/i/guarantees/'+ g2 +'-guarantee-'+ lang +'.png )'
            }
           
            let link2 = null;
            if (g2 == 'pret')
                link2 = <Link key="guarantee-1" to={`/${lang}/${"our-values/our-food/coffee"}`}className="item guarantees" title="Learn More" style={g2_style}><span className="guarantee-link"><h3>{this.props.lang === 'en' ? 'Learn more' : 'En apprendre plus'} <Icon type="gt-inverted" /></h3></span></Link>
            else if (g2 == 'location')
                link2 = <Link key="guarantee-1" to={`/${lang}/${"locations#brewbar"}`}className="item guarantees" title="Learn More" style={g2_style}><span className="guarantee-link"><h3>{this.props.lang === 'en' ? 'Learn more' : 'En apprendre plus'} <Icon type="gt-inverted" /></h3></span></Link>
            else
                link2 = <Link key="guarantee-1" to={`/${lang}/${"our-values/our-food/"}${g2}`}className="item guarantees" title="Learn More" style={g2_style}><span className="guarantee-link"><h3>{this.props.lang === 'en' ? 'Learn more' : 'En apprendre plus'} <Icon type="gt-inverted" /></h3></span></Link>
            let index = Math.floor(Math.random()*menuItems.length);
            menuItems.splice(index, 0, link2);
        }

        return(menuItems)
        
    }
    render() {
        //console.log('items food ',this.props.categoryFood);
        //console.log('cat: ', this.state.cat);
        let categoryItems = this.prepareItems(this.props.categoryFood, this.props.categoryGuarantees)
        const rows = (this.props.initialCategory == 'featured' || this.shouldSubCategorize() ? 1 : 2);
        let width = this.props.isDesktop ? 291 * Math.ceil(categoryItems.length / rows) + 'px' : 45*Math.ceil(categoryItems.length / rows) + "vw";
        let style = {
			width: width
		};
        return (

            <Suspense fallback={<div>loading</div>}>
                {/* <Slider ref="slider" {...settings}  className="items" scrollCallback={this.scrollCallback}> */}
                    <div className="our-menu-items-wrapper"  ref={this.menuSlider}>
                    <div className={"ui rows" + rows} ref={this.arrowsWrapper}>
                                <button className="left arrow" aria-label="move left" onClick={() => this.shift('-3')}><Icon inverted={true} type="gt-inverted" /></button>
                                <button className="right arrow" aria-label="move right" onClick={() => this.shift('3')}><Icon inverted={true} type="gt-inverted" /></button>
                            </div>
                        <div className="our-menu-items"  style={style} ref={this.menuWidth} >
                           
                            {categoryItems}
                            
                        </div>
                        
                    </div>
                   
                {/* </Slider> */}
            </Suspense>    
            
        );
    }
}

export default CategoryItems;